// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.automation_tab-button__iO6ji {
    background-color: #FFFFFF;
    color: #5D8EA4;
    width: 126px;
    height: 34px;
    font-size: 14px;
    border-radius: 5px;
    border: none;
    margin-right: 5px;
}

.automation_notification-container__p9H7Z {
    overflow-y: scroll;
    max-height: 70vh
}

.automation_notification-container__p9H7Z::-webkit-scrollbar {
    display: none;
}

.automation_add-layer-button__0aWxy {
    background: var(--color-content-highlight);
    color: var(--color-sidebar-typography-active);
    border: none;
    min-width: 101px;
    height: 34px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 450;
    margin-top: 15px;
    margin-bottom: 15px;
}

.automation_add-layer-button__0aWxy {
    outline: none
}

.automation_clear-button__z\\+o03 {
    background: transparent;
    color: var(--color-status-red);
    border: 1px solid var(--color-status-red);
    min-width: 101px;
    height: 34px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 450;
    margin-top: 15px;
    margin-bottom: 15px;
}

.automation_clear-button__z\\+o03 {
    outline: none
}

.automation_table-controls__KXTWz {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: flex-start;
}

.automation_tab-button-active__fGjzX {
    background-color: #0095FF;
    color: #FFFFFF;
}

.automation_tab-content-container__PGp4E {
    margin-top: 20px;
    width: 100%
}

.automation_form-textfield__U3Zfi {
    margin-bottom: 10px
}

.automation_server-content__gzIR- {
    padding: 30px;
    background-color: var(--color-content);
    color: var(--color-main-typography);

    width: 100%;
    height: 100vh;
}

.automation_server-tabs-background__sA8AE {
    width: 100%;
    height: 100%;
    background-color: var(--color-content-sidebar);
    padding: 5px;
    border-radius: 5px;;
}

.automation_server-content-info-url-container__AJQgD {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    margin-top: 20px
}

.automation_server-content-info-url-container-item__JpEiy {
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: flex-start;
    width: 183px;
}

.automation_server-settings-button__sc9du {
    border: 1px solid #0095FF;
    color: #0095FF;
    background: none;
    width: 101px;
    height: 34px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 450
}

.automation_server-settings-secondary__HAv97 {
    font-size: 10px;
    font-weight: 450;
    color: #8E99A0
}

.automation_server-settings-highlighted__Bw4DV {
    font-size: 12px;
    font-weight: 450;
    color: #0095FF;
    text-decoration: underline;
}

.automation_servers-info-table__RqMt4 {
    border-collapse: collapse;
    width: 90%;
    margin-top: 10px;
}

.automation_servers-info-row__yTHhC {
    border: none;
    height: 34px;
    text-align: left;
    font-size: 14px;
    font-weight: 450;
    padding: 5px;
    color: var(--color-secondary-typography);
}

.automation_servers-info-row__yTHhC:nth-child(odd) {
    background-color: var(--color-content-sidebar);
}

.automation_mainWrapper__lGFsp {
    flex: 1 1;
    height: 100vh;
    display: flex;
    align-items: flex-start;
}

.automation_rightBlock__zBJrY {
    flex: 1 1;
    background: var(--color-content);
    height: 100vh;
    padding: 30px;
    color: var(--color-main-typography)
}

.automation_search-controls-container__-t9C8 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 0;
}

.automation_search-field-container__e6Ip8 {
    display: flex;
    flex: 16 1;
}

.automation_search-filter-container__InTnD {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 3 1;
}

.automation_content-heading__-Nvn\\+ {
    margin-bottom: 40px;
    font-weight: 700;
    font-size: 20px;
}

.automation_content-container__9Gml9 {
    padding: 0;
}

.automation_search-controls__Seq1D {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
}

.automation_search-container__AqD9p {
    width: 444px;
}


.automation_zone-table__PNvSq {
    border-collapse: separate;
    border-spacing: 0 10px;
    width: 100%;
}

.automation_zone-cell__0gBda {
    border-bottom: 1px solid var(--color-inactive-filter);
    border-left: none;
    border-right: none;
}

.automation_type-cell__Qnhug {
    padding-right: 40px;
}

.automation_base-button__F83oI {
    border: 1px solid var(--color-icon-stroke);
    border-radius: 5px;
    background: transparent;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
}

.automation_base-button__F83oI:focus {
    outline: none;
}

.automation_red-button__PGQgS {
    border: 1px solid var(--color-status-red);
    border-radius: 5px;
    background: transparent;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
}

.automation_red-button__PGQgS:focus {
    outline: none;
}

.automation_green-button__OCAlJ {
    border: 1px solid var(--color-status-green);
    border-radius: 5px;
    background: transparent;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
}

.automation_green-button__OCAlJ:focus {
    outline: none;
}

.automation_button-container__RhfBq {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
}

.automation_middle-cell-align__yGEOe {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

@media screen and (max-width: 1000px) {
    .automation_server-content-info-url-container__AJQgD {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 5px;
        margin-top: 20px
    }

    .automation_mainWrapper__lGFsp {
        width: 100%;
    }

    .automation_rightBlock__zBJrY {
        background: var(--color-content);
        height: 100vh;
        padding: 30px;
        width: 100%;
        padding: 0;
    }
    .automation_content-container__9Gml9 {
        padding: 30px;
    }

    .automation_content-heading-container__6BhkL {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/add-zone-rule-form-content/automation.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0CAA0C;IAC1C,6CAA6C;IAC7C,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,yCAAyC;IACzC,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,mCAAmC;;IAEnC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qDAAqD;IACrD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,2BAA2B;QAC3B,QAAQ;QACR;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gCAAgC;QAChC,aAAa;QACb,aAAa;QACb,WAAW;QACX,UAAU;IACd;IACA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;IAClC;AACJ","sourcesContent":[".tab-button {\n    background-color: #FFFFFF;\n    color: #5D8EA4;\n    width: 126px;\n    height: 34px;\n    font-size: 14px;\n    border-radius: 5px;\n    border: none;\n    margin-right: 5px;\n}\n\n.notification-container {\n    overflow-y: scroll;\n    max-height: 70vh\n}\n\n.notification-container::-webkit-scrollbar {\n    display: none;\n}\n\n.add-layer-button {\n    background: var(--color-content-highlight);\n    color: var(--color-sidebar-typography-active);\n    border: none;\n    min-width: 101px;\n    height: 34px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 450;\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n\n.add-layer-button {\n    outline: none\n}\n\n.clear-button {\n    background: transparent;\n    color: var(--color-status-red);\n    border: 1px solid var(--color-status-red);\n    min-width: 101px;\n    height: 34px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 450;\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n\n.clear-button {\n    outline: none\n}\n\n.table-controls {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.tab-button-active {\n    background-color: #0095FF;\n    color: #FFFFFF;\n}\n\n.tab-content-container {\n    margin-top: 20px;\n    width: 100%\n}\n\n.form-textfield {\n    margin-bottom: 10px\n}\n\n.server-content {\n    padding: 30px;\n    background-color: var(--color-content);\n    color: var(--color-main-typography);\n\n    width: 100%;\n    height: 100vh;\n}\n\n.server-tabs-background {\n    width: 100%;\n    height: 100%;\n    background-color: var(--color-content-sidebar);\n    padding: 5px;\n    border-radius: 5px;;\n}\n\n.server-content-info-url-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 5px;\n    margin-top: 20px\n}\n\n.server-content-info-url-container-item {\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    justify-content: flex-start;\n    width: 183px;\n}\n\n.server-settings-button {\n    border: 1px solid #0095FF;\n    color: #0095FF;\n    background: none;\n    width: 101px;\n    height: 34px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 450\n}\n\n.server-settings-secondary {\n    font-size: 10px;\n    font-weight: 450;\n    color: #8E99A0\n}\n\n.server-settings-highlighted {\n    font-size: 12px;\n    font-weight: 450;\n    color: #0095FF;\n    text-decoration: underline;\n}\n\n.servers-info-table {\n    border-collapse: collapse;\n    width: 90%;\n    margin-top: 10px;\n}\n\n.servers-info-row {\n    border: none;\n    height: 34px;\n    text-align: left;\n    font-size: 14px;\n    font-weight: 450;\n    padding: 5px;\n    color: var(--color-secondary-typography);\n}\n\n.servers-info-row:nth-child(odd) {\n    background-color: var(--color-content-sidebar);\n}\n\n.mainWrapper {\n    flex: 1;\n    height: 100vh;\n    display: flex;\n    align-items: flex-start;\n}\n\n.rightBlock {\n    flex: 1;\n    background: var(--color-content);\n    height: 100vh;\n    padding: 30px;\n    color: var(--color-main-typography)\n}\n\n.search-controls-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    padding: 0;\n}\n\n.search-field-container {\n    display: flex;\n    flex: 16;\n}\n\n.search-filter-container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex: 3;\n}\n\n.content-heading {\n    margin-bottom: 40px;\n    font-weight: 700;\n    font-size: 20px;\n}\n\n.content-container {\n    padding: 0;\n}\n\n.search-controls {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.search-container {\n    width: 444px;\n}\n\n\n.zone-table {\n    border-collapse: separate;\n    border-spacing: 0 10px;\n    width: 100%;\n}\n\n.zone-cell {\n    border-bottom: 1px solid var(--color-inactive-filter);\n    border-left: none;\n    border-right: none;\n}\n\n.type-cell {\n    padding-right: 40px;\n}\n\n.base-button {\n    border: 1px solid var(--color-icon-stroke);\n    border-radius: 5px;\n    background: transparent;\n    outline: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n}\n\n.base-button:focus {\n    outline: none;\n}\n\n.red-button {\n    border: 1px solid var(--color-status-red);\n    border-radius: 5px;\n    background: transparent;\n    outline: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n}\n\n.red-button:focus {\n    outline: none;\n}\n\n.green-button {\n    border: 1px solid var(--color-status-green);\n    border-radius: 5px;\n    background: transparent;\n    outline: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n}\n\n.green-button:focus {\n    outline: none;\n}\n\n.button-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n}\n\n.middle-cell-align {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n@media screen and (max-width: 1000px) {\n    .server-content-info-url-container {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-start;\n        gap: 5px;\n        margin-top: 20px\n    }\n\n    .mainWrapper {\n        width: 100%;\n    }\n\n    .rightBlock {\n        background: var(--color-content);\n        height: 100vh;\n        padding: 30px;\n        width: 100%;\n        padding: 0;\n    }\n    .content-container {\n        padding: 30px;\n    }\n\n    .content-heading-container {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab-button": `automation_tab-button__iO6ji`,
	"notification-container": `automation_notification-container__p9H7Z`,
	"add-layer-button": `automation_add-layer-button__0aWxy`,
	"clear-button": `automation_clear-button__z+o03`,
	"table-controls": `automation_table-controls__KXTWz`,
	"tab-button-active": `automation_tab-button-active__fGjzX`,
	"tab-content-container": `automation_tab-content-container__PGp4E`,
	"form-textfield": `automation_form-textfield__U3Zfi`,
	"server-content": `automation_server-content__gzIR-`,
	"server-tabs-background": `automation_server-tabs-background__sA8AE`,
	"server-content-info-url-container": `automation_server-content-info-url-container__AJQgD`,
	"server-content-info-url-container-item": `automation_server-content-info-url-container-item__JpEiy`,
	"server-settings-button": `automation_server-settings-button__sc9du`,
	"server-settings-secondary": `automation_server-settings-secondary__HAv97`,
	"server-settings-highlighted": `automation_server-settings-highlighted__Bw4DV`,
	"servers-info-table": `automation_servers-info-table__RqMt4`,
	"servers-info-row": `automation_servers-info-row__yTHhC`,
	"mainWrapper": `automation_mainWrapper__lGFsp`,
	"rightBlock": `automation_rightBlock__zBJrY`,
	"search-controls-container": `automation_search-controls-container__-t9C8`,
	"search-field-container": `automation_search-field-container__e6Ip8`,
	"search-filter-container": `automation_search-filter-container__InTnD`,
	"content-heading": `automation_content-heading__-Nvn+`,
	"content-container": `automation_content-container__9Gml9`,
	"search-controls": `automation_search-controls__Seq1D`,
	"search-container": `automation_search-container__AqD9p`,
	"zone-table": `automation_zone-table__PNvSq`,
	"zone-cell": `automation_zone-cell__0gBda`,
	"type-cell": `automation_type-cell__Qnhug`,
	"base-button": `automation_base-button__F83oI`,
	"red-button": `automation_red-button__PGQgS`,
	"green-button": `automation_green-button__OCAlJ`,
	"button-container": `automation_button-container__RhfBq`,
	"middle-cell-align": `automation_middle-cell-align__yGEOe`,
	"content-heading-container": `automation_content-heading-container__6BhkL`
};
export default ___CSS_LOADER_EXPORT___;
